<template>
	<div class="home" v-loading="loading">
		<el-row v-if="xuanfu != null && shijian > 0">
			<div class="xuanfu">
				<div :style="{backgroundImage:'url(' + xuanfu.showpath + ')'}" @click="linkrouter(xuanfu.uuid)"></div>
				<p class="bottom_text">{{xuanfu.title}}</p>
				<p
					style="position: absolute;right: 50px;top: 25px;border-radius: 50%;width: 30px;height: 30px;font-size: 16px;text-align: center;line-height: 30px;background-color: rgba(0, 0, 0, 0.6);color: #fff;">
					{{shijian}}</p>
			</div>
		</el-row>
		<el-row>
			<el-carousel height="594px" :interval="3000" arrow="none">
				<el-carousel-item v-for="(item, index) in list" :key="index">
					<div class="gundong" :style="{
              backgroundImage: 'url(' + item.img + ')',
              cursor: item.toPath ? 'pointer' : 'auto',
            }" @click="handelToPath(item.toPath)"></div>
				</el-carousel-item>
			</el-carousel>
		</el-row>
		<!-- <el-row>
      <titles :forms="datas"></titles>
    </el-row> -->
		<el-row>
			<div class="home_h1">
				<p class="homeh_p1">关于我们</p>
				<p class="homeh_p2"></p>
				<p class="homeh_p3">scope of business</p>
			</div>
			<div class="home_div">
				<div class="home_left">
					<h1>中艺储运江苏有限责任公司</h1>
					<p>{{jianjie.baktwo}}</p>
					<div class="home_divleft">
						<div>
							<span>Mobile：{{Mobile}}</span>
							<span>E-mail：{{mail}}</span>
							<span>Website：{{Website}}</span>
						</div>
						<div class="btnp" @click="toWithOur" style="margin-left:40px">
							<div class="btnps">
								<p>查看更多</p>
							</div>
							<div class="btnimg">
								<img src="@/assets/home/rights.png" alt="" />
							</div>
						</div>
					</div>
				</div>
				<div class="home_right">
					<div><img :src="jianjie.showpath" alt="" /></div>
				</div>
			</div>
		</el-row>
		<el-row>
			<div class="home_business">
				<div class="home_b1">
					<p class="homeBusiness_p1">业务范围</p>
					<p class="homeBusiness_p2"></p>
					<p class="homeBusiness_p3">SCOPE OF BUSINESS</p>
					<p class="homeBusiness_p4">中艺储运江苏有限责任公司服务覆盖全国各区域，其中尤以湖南、湖北、江西、安徽、江苏、上海及周边地区为主；主要从事长江中下游区域进出口货物的海、陆、空、拖车、仓储、DDU、DDP等国际货运代理业务。</p>
					<!-- <p class="homeBusiness_p4">
						中艺国际储运公司江苏公司主要从事江苏、上海及周边地区和长江中下游区域进出口货物的海、陆、空国际货运代理业务
						包括：揽货、包装、存储、集装箱拆拼装箱服务、送货上门、短途运输服务、保险、报检、报关、订舱、转运、缮制各种单证；国际船舶代理，无船承运业务。
					</p> -->
					<div class="homeB_img">
						<div v-for="(item, index) in list2" :key="index">
							<!-- <router-link class="tiaozhuan" :to="{ name: 'publicPage' }">
								<img :src="item.img" alt="" />
								<p>{{ item.p }}</p>
							</router-link> -->
							<div class="tiaozhuan">
								<img :src="item.img" alt="" />
								<p>{{ item.p }}</p>
							</div>
						</div>
					</div>
					<div @click="toServePlace" class="btnp">
						<div class="btnps">
							<p style="color: ;">查看更多</p>
						</div>
						<div class="btnimg">
							<img src="@/assets/home/rights.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</el-row>
<!-- 		<div class="home_examples">
			<div class="homeE_div">
				<p class="homeE_p1">案例展示</p>
				<p class="homeE_p2"></p>
				<p class="homeE_p3">Case presentation</p>
			</div>
			<div class="homeE_conter">
				<div class=" divB"><img src="@/assets/home/b1.png" alt="" /></div>
				<div class="divB divL divR">
					<img src="@/assets/home/b2.png" alt="" />
				</div>
				<div class="divB "><img src="@/assets/home/b3.png" alt="" /></div>
				<div><img src="@/assets/home/b4.png" alt="" /></div>
				<div class="divL divR"><img src="@/assets/home/b5.png" alt="" /></div>
				<div><img src="@/assets/home/b6.png" alt="" /></div>
			</div>
			<div class="btnp" @click="toCompany">
				<div class="btnps">
					<p style="color:#000">查看更多</p>
				</div>
				<div class="btnimg">
					<img src="@/assets/home/rights.png" alt="" />
				</div>
			</div>
		</div> -->
		<!-- 新闻咨询 -->
		<el-row>
			<div class="home_new">
				<div class="home_b1">
					<p class="homenew_p1">新闻资讯</p>
					<p class="homenew_p2"></p>
					<p class="homenew_p3">News and information</p>

					<div class="homeN_img" @mouseenter="jinlai()" @mouseleave="likai()" v-if="list3.length > 0">
						<div>
							<div class="diyige" :style="{backgroundImage:'url(' + list3[xuanzhong].img + ')'}"
								@click="linkrouter(list3[xuanzhong].uuid)"></div>
							<!-- <img @click="linkrouter(list3[0].uuid)" :src="list3[0].img" alt="" /> -->
							<p class="bottom_text">{{list3[xuanzhong].p1}}</p>
						</div>
						<div class="homeN_div">
							<div v-for="(item, index) in list3" :key="index" :class="[{ selected: xuanzhong==index }, 'homeN_img1']" @click="linkrouter(item.uuid)" @mouseenter="xuanze(index)">
								<div>
									<img :src="item.img" alt="" />
								</div>
								<div class="homeN_p">
									<p class="homeN_p1">
										{{ item.p1 }}
									</p>
									<p class="homeN_p2">{{ item.d2 }}</p>
								</div>
							</div>
						</div>
					</div>
					<div @click="tonews" class="btnp2">
						<div class="btnps2">
							<p>查看更多</p>
						</div>
						<div class="btnimg2">
							<img src="@/assets/home/rights2.png" alt="" />
						</div>
					</div>
				</div>
			</div>
		</el-row>
		<el-row>
			<!-- 在线留言 -->
			<div class="home_message">
				<div class="homeM_left" v-loading="loading1">
					<p class="homeM_p1">在线留言</p>
					<p class="homeM_p2">Online Message</p>
					<div>
						<!-- <el-input placeholder="姓名Name" v-model="msg.name"></el-input> -->
						<el-input placeholder="手机Phone" v-model="msg.phone"></el-input>
						<el-input placeholder="邮箱E-mail" v-model="msg.email"></el-input>
						<el-input type="textarea" :autosize="{ minRows: 6, maxRows: 10 }" placeholder="请输入内容"
							v-model="msg.detail">
						</el-input>
						<el-button style="width:100%;background: #F08800;color:#fff;margin-top:20px"
							@click="handelClickSubMit">提交</el-button>
					</div>
				</div>
				<div class="homeM_right">
					<maps></maps>
				</div>
			</div>
		</el-row>
		<!-- 外部链接 -->
		<el-row>
			<div class="homeJ" v-if="list4.length==0?false:true">
				<p class="homeJ_p">友情链接</p>
				<div class="homeJ_body">
					<div class="homeJ_div" v-for="(item, index) in list4" :key="index" @click="jump(item)">
						<p style="padding:5px 0">{{ item.companyname }}</p>
					</div>
				</div>
			</div>
		</el-row>

		<!-- <el-row>
		      <a
		        href="tencent://Message/?Uin=1922261192&amp;websiteName=local.edu.com:8888=&amp;Menu=yes"
		        class="btn btn-qq"
		        ><img
		          border="0"
		          src="http://pub.idqqimg.com/wpa/images/counseling_style_53.png"
		          alt="hello xym!!"
		          title="hello xym!!"
		      /></a>
		    </el-row> -->
		<div class="fixd" @click="opens">
			<a href="javascript:void(0)" id="contactQQ">联系我们</a>
			<!-- <p>联系我们</p> -->
		</div>
		<el-row>
			<div class="qqlist">
				<el-dialog title="提示" :visible.sync="dialogVisible" width="300px" height="400px"
					:before-close="handleClose">
					<div class="qqposition" @click="handleClose">
						<img src="@/assets/qq/close1.png" alt="" />
					</div>
					<div class="qqdiv">
						<p class="qqdiv_p1">{{name}}</p>
						<p class="qqdiv_p2">优质服务 良好资信</p>
					</div>
					<div class="qqdiv1">
						<p class="qqdiv1_p1">联系方式</p>
						<p class="qqdiv1_p2">
							<img src="@/assets/qq/phone.png" alt="" /> {{phone}}
						</p>
					</div>
					<div class="qqdiv2">
						<p class="qqdiv2_p1">在线咨询</p>
						<div class="qqdiv2_p2">
							<a :href="href" class="btn btn-qq"><img border="0" src="@/assets/qq/qq.png"
									alt="hello xym!!" title="hello xym!!" /></a>
						</div>
					</div>
				</el-dialog>
			</div>
		</el-row>
	</div>
</template>

<script>
	// import '../utils/rem.js';
	import titles from "@/components/Titles";
	import maps from "@/components/map";
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	export default {
		name: "HelloWorld",
		components: {
			swiper,
			titles,
			swiperSlide,
			maps,
		},
		data() {
			return {
				dingshi:null,
				xuanzhong:0,
				dialogVisible: false,
				textarea2: "",
				name: '',
				phone: '',
				href: '',
				msg: {
					name: '',
					phone: '',
					email: '',
					detail: ''
				},
				list: [],
				list2: [{
						img: require("@/assets/home/h1.jpg"),
						p: "海运集装箱",
					},
					{
						img: require("@/assets/home/h2.jpg"),
						p: "铁路",
					},
					{
						img: require("@/assets/home/h3.jpg"),
						p: "海铁联运",
					},
				],
				list3: [],
				list4: [],
				datas: {
					h1: "关于我们",
					h2: "ABOUT US",
				},
				loading: true,
				caseList: [],
				loading1: false,
				jianjie: {},
				xuanfu: [],
				shijian: 5,
				Mobile:'',
				mail:'',
				Website:'',
			};
		},
		created() {},
		// 如果你需要得到当前的swiper对象来做一些事情，你可以像下面这样定义一个方法属性来获取当前的swiper对象，同时notNextTick必须为true
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			},
		},
		beforeDestroy() {
			var that = this;
			if(that.dingshi){
				clearInterval(that.dingshi);
			}
		},
		mounted() {
			this.close();
			this.loading = false;
			this.getData();
			this.getlunbo();
			this.getlist();
			this.getlianjie();
			this.getjianjie();
			this.getfuchuang();
			this.$axios({
					method: "get",
					url: "webpc/pcmastercompany/list",
					params: {}
				}).then(res => {
					if (res.data.result == 200) {
						this.Mobile=res.data.detail.phone
						this.mail=res.data.detail.email.split('/')[0],
						this.Website=res.data.detail.email.split('/')[1]
					}
				
				})
			setInterval(this.daojishi, 1000);
		},
		methods: {
			xuanze(a){
				this.xuanzhong = a;
			},
			jinlai(){
				var that = this;
				if(that.dingshi){
					clearInterval(that.dingshi);
				}
			},
			likai(){
				var that = this;
				if(that.list3.length > 1){
					that.dingshi = setInterval(function() {
						var length = that.list3.length - 1;
						if(that.xuanzhong == length){
							that.xuanzhong = 0;
						}else{
							that.xuanzhong++;
						}
					}, 3000);
				}
			},
			getData() {
				var that = this;
				that.$axios({
					method: "get",
					url: "webpc/pcmastercompany/list",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						var data = res.data.detail;
						that.name = data.master_name;
						that.phone = data.phone;
						that.href = 'tencent://Message/?Uin=' + data.qq +
							'&amp;websiteName=local.edu.com:8888=&amp;Menu=yes';
					}

				})
			},
			daojishi() {
				this.shijian--;
			},
			//公司简介
			getjianjie() {
				var that = this;
				that.$http.get('webpc/pccompanyabstract/list', {
					params: {
						page: 1,
						pagesize: 10
					}
				}, {
					emulateJSON: true
				}).then(res => {
					if (res.data.result == 200) {
						this.jianjie = res.data.detail.list[1];
					}
				})
			},
			getlunbo() {
				var that = this;
				that.$axios({
					method: "get",
					url: "system/pcmanage/list",
					// data: this.$qs.stringify(data)
					params: {
						location: 0
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						var data = res.data.detail;
						that.list = [];
						for (var i = 0; i < data.length; i++) {
							if (data[i].content == null) {
								that.list.push({
									img: data[i].showpath
								})
							} else {
								that.list.push({
									img: data[i].showpath,
									toPath: data[i].content
								})
							}
						}
					}

				})
			},
			//友情链接
			getlianjie() {
				var that = this;
				that.$axios({
					method: "post",
					url: "webpc/pcfriendlylink/list",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
						page: 1,
						pagesize: 1000
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						that.list4 = res.data.detail.list;

					}

				})
			},
			//浮窗
			getfuchuang() {
				var that = this;
				that.$axios({
					method: "post",
					url: "webpc/pcnewsmessige/getTopflagInfo",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					// console.log(res.data.data);
					if (res.data.result == 200) {
						that.xuanfu = res.data.detail;

					}

				})
			},
			getlist() {
				var that = this;
				that.$axios({
					method: "post",
					url: "webpc/pcnewsmessige/list",
					// data: this.$qs.stringify(data)
					params: {
						// location:0
						page: 1,
						pagesize: 30
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					console.log('新闻列表-------')
					console.log(res.data);
					if (res.data.result == 200) {
						var data = res.data.detail;
						var list = data.list;
						// console.log(list);
						that.list3 = [];
						for (var i = 0; i < list.length; i++) {
							// if(i < 3){
								that.list3.push({
									img: list[i].showpath,
									p1: list[i].title,
									p2: list[i].descp,
									d1: '查看详情',
									d2: list[i].createtime.slice(0, 10),
									uuid: list[i].uuid
								})
							// }
							
						}
						if(that.list3.length > 1){
							that.dingshi = setInterval(function() {
								var length = that.list3.length - 1;
								if(that.xuanzhong == length){
									that.xuanzhong = 0;
								}else{
									that.xuanzhong++;
								}
							}, 3000);
						}

						console.log('list3-------', this.list3)
					}

				})

			},
			handelToPath(e) {
				//轮播图跳转
				if (e && e.length > 0) {
					window.scroll(0, 0);
					this.$router.push({
						path: "/" + e,
					});
				}
			},
			handelClickSubMit() {
				//提交按钮

				var that = this;

				// if(that.msg.name.trim() == ''){
				// 	that.$message.error("请填写姓名");
				// 	return;
				// }
				if (that.msg.phone.trim() == '') {
					that.$message.error("请填写手机");
					return;
				}
				if (that.msg.email.trim() == '') {
					that.$message.error("请填写邮箱");
					return;
				}
				if (that.msg.detail.trim() == '') {
					that.$message.error("请填写内容");
					return;
				}
				that.loading1 = true;
				that.$axios({
					method: "post",
					url: "webpc/pconlinemessage/list",
					// data: this.$qs.stringify(data)
					params: {
						email: that.msg.email,
						descp: that.msg.detail,
						type: 0,
						phone: that.msg.phone
					}
				}).then(res => {
					// console.log(JSON.stringify(res.data));
					var data = res.data.data;
					that.loading1 = false;
					if (res.data.result == 200) {
						that.$message({
							message: '提交成功',
							type: 'success'
						});
						that.msg.email = '';
						that.msg.detail = '';
						that.msg.phone = '';
						// var data = result.data.data;
						// that.zhengshu = [];
						// for(var i = 0;i<data.length;i++){
						// 	that.zhengshu.push({
						// 		tu:data[i].attas[0].path
						// 	});
						// }

					}
				})
			},
			opens() {
				this.dialogVisible = true;
			},
			//是否有缓存
			close() {
				if (sessionStorage.getItem("isclose")) {
					this.dialogVisible = false;
				} else {
					this.dialogVisible = true;
				}
			},
			handleClose() {
				this.dialogVisible = false;
				sessionStorage.setItem("isclose", "true");
			},
			linkrouter(a) {
				window.scroll(0, 0);

				var route = '/publicPage?uuid=' + a;
				this.$router.push(route);
			},
			routerlink(value) {
				switch (value) {
					case "关于我们":
						this.$router.push({
							path: "/download",
						});
						break;
				}
			},
			jump(value) {
				window.open(value.link);
			},
			toWithOur() {
				window.scroll(0, 0);
				this.$router.push({
					path: "/aboutus",
				});
			},
			toServePlace() {
				window.scroll(0, 0);
				this.$router.push({
					path: "/product?id=four",
				});
			},
			toCompany() {
				window.scroll(0, 0);
				this.$router.push({
					path: "/product?id=three",
				});
			},
			tonews(){
				window.scroll(0, 0);
				this.$router.push({
					path: "/News",
				});
			}
		},
	};
</script>

<style lang="scss" scoped>
	.btnp2 {
		max-width: 140px;
		margin: 20px 0 0 0px;
		display: grid;
		border: 1px solid #5083e3;
		border-radius: 5px;
		grid-template-columns: 60% 40%;
		cursor: pointer;
	
		.btnps2 {
			p {
				height: 35px;
				width: 120px;
	
				color: #5083e3;
				display: grid;
				place-items: center;
			}
		}
	
		.btnimg2 {
			display: grid;
			justify-items: start;
			align-items: center;
			padding-left: 10px;
		}
	}
	.tiaozhuan{
		display: block;
		img{
			display: block;
		}
	}
	// 在线qq
	.qqposition {
		width: 27px;
		height: 27px;
		position: absolute;
		top: -10px;
		right: -10px;
	}

	.qqdiv {
		width: 100%;
		height: 79px;

		background: #3ba6e3;

		margin: auto;
		text-align: center;
		color: #ffffff;
		line-height: 20px;

		.qqdiv_p1 {
			padding-top: 20px;

			font-size: 18px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
		}

		.qqdiv_p2 {
			padding-top: 10px;

			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
		}
	}

	.qqdiv1 {
		width: 100%;
		height: 60px;

		.qqdiv1_p1 {
			padding-top: 10px;
			padding-left: 18px;

			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #3d3d3d;
		}

		.qqdiv1_p2 {
			padding-left: 18px;
			font-size: 16px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #1b90e1;
		}
	}

	.qqdiv2 {
		margin-top: 10px;
		width: 100%;
		height: 120px;

		.qqdiv2_p1 {
			padding-left: 18px;
			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #3d3d3d;
		}

		.qqdiv2_p2 {
			display: grid;
			place-items: center;
		}
	}

	.qqlist {
		::v-deep.el-dialog__header {
			display: none;
		}

		::v-deep.el-dialog__body {
			padding: 0;

			border-radius: 8px 10px 0px 0px;
		}
	}

	.home_h1 {
		display: grid;
		width: 62.5%;
		margin: 20px auto;

		place-items: center;

		.homeh_p1 {
			margin-top: 10px;
			font-size: 30px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #242424;
		}

		.homeh_p2 {
			margin-top: 10px;
			width: 50px;
			height: 2px;
			background: #ff9c22;
		}

		.homeh_p3 {
			margin-top: 5px;
			font-size: 30px;
			font-family: Arial;
			font-weight: bold;
			color: #0083c9;
		}
	}

	#contactQQ {
		display: inline-block;
		text-align: center;
		color: #ffffff;
		line-height: 20px;
		padding-top: 95px;
	}

	.fixd {
		width: 30px;
		height: 250px;

		background-image: url(../assets/img/iconss.png);
		background-position: center;
		background-size: 100%;
		// background-attachment: fixed;
		background-repeat: no-repeat;
		position: fixed;
		bottom: 10%;
		right: 0;
		z-index: 20;

		p {
			text-align: center;
			color: #ffffff;
			line-height: 20px;
			padding-top: 95px;
		}
	}

	::v-deep.el-input {
		margin-top: 20px;
	}

	::v-deep.el-textarea {
		margin-top: 20px;
	}

	.divR {
		border-right: 1px solid #bfbfbf;
	}

	.divB {
		border-bottom: 1px solid #bfbfbf;
	}

	.divL {
		border-left: 1px solid #bfbfbf;
	}

	.btnp {
		max-width: 140px;
		margin: 20px 0 0 0px;
		display: grid;
		border: 1px solid #bfbfbf;
		border-radius: 5px;
		grid-template-columns: 60% 40%;
		cursor: pointer;

		.btnps {
			p {
				height: 35px;
				width: 120px;

				color: #fff;
				display: grid;
				place-items: center;
			}
		}

		.btnimg {
			display: grid;
			justify-items: start;
			align-items: center;
			padding-left: 10px;
		}
	}

	::v-deep.el-carousel__container {
		height: 50vh;
	}

	.home_div {
		width: 62.5%;
		// height: 65vh;
		display: grid;
		grid-template-columns: 50% 50%;
		padding: 20px 0;
		margin: 0 auto 40px;

		.home_left {
			width: 100%;
			height: 100%;
			line-height: 30px;
			h1 {
				font-size: 18px;
				padding-right: 40px;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #404040;
				line-height: 30px;
			}
			p {
				// margin-top: 10px;
				font-size: 16px;
				padding-right: 40px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #404040;
				line-height: 29px;
				margin: 10px 0;
			}

			.home_divleft {
				width: 100%;
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				padding-right: 60px;
				box-sizing: border-box;
				align-items: center;

				.btnp {
					margin-top: 10px;
					height: 40px;
					display: flex;
					flex-direction: row;
					width: 130px;
					align-items: center;
					justify-content: space-between;
					padding: 0 13px;
					box-sizing: border-box;
					cursor: pointer;

					.btnps {
						p {
							width: auto;
							margin: 0;
							padding: 0;
						}
					}
				}

				.btnimg {
					padding: 0;
				}

				div {
					font-size: 16px;
					display: flex;
					flex-direction: column;
					font-weight: 300;
				}
			}
		}

		.home_right {
			width: 100%;
			height: 100%;
			display: grid;
			grid-template-columns:100%;
			grid-column-gap: 10px;
			.home_imgright {
				width: 100%;
				height: 100%;
				display: grid;
				grid-row-gap: 10px;
				grid-template-rows: 1fr 1fr;
			}

			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.home_examples {
		width: 62.5%;
		height: 50vh;
		margin: auto;
		display: grid;
		place-items: center;

		.homeE_div {
			width: 100%;

			display: grid;
			place-items: center;

			.homeE_p1 {
				margin-top: 10px;
				font-size: 30px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #242424;
			}

			.homeE_p2 {
				margin-top: 10px;
				width: 50px;
				height: 2px;

				background: #ff9c22;
			}

			.homeE_p3 {
				margin-top: 10px;
				font-size: 30px;
				font-family: Arial;
				font-weight: bold;

				color: #0083c9;
			}
		}

		.homeE_conter {
			// margin: 20px auto;
			width: 100%;
			height: 100%;
			display: grid;
			place-items: center;
			grid-template-columns: 1fr 1fr 1fr;
			grid-template-rows: 1fr 1fr;

			div {
				height: 100%;
				width: 100%;
				display: grid;
				place-items: center;

				img {
					max-width: 130px;
					max-height: 40px;
				}
			}
		}
	}

	.home_business {
		width: 100%;
		// height: 50vh;
		padding: 30px 0 50px 0;
		background-image: url(../assets/home/backimg.jpg);
		background-position: center;
		background-size: 100% 100%;
		background-position: 100% 100%;
		background-repeat: no-repeat;

		.homeB_img {
			display: grid;
			margin-top: 20px;
			grid-template-columns: 1fr 1fr 1fr;
			grid-column-gap: 20px;
			margin-bottom: 30px;

			img {
				width: 100%;
			}

			p {
				// margin-top: -5px;
				display: grid;
				place-items: center;
				height: 50px;
				background: #314773;
				opacity: 0.89;
				color: #fff;
			}
		}

		.home_b1 {
			display: grid;
			width: 62.5%;
			margin: auto;

			place-items: center;

			.homeBusiness_p1 {
				margin-top: 10px;
				font-size: 30px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #ffffff;
			}

			.homeBusiness_p2 {
				margin-top: 10px;
				width: 50px;
				height: 2px;
				background: #ffffff;
			}

			.homeBusiness_p3 {
				margin-top: 5px;
				font-size: 30px;
				font-family: Arial;
				font-weight: bold;
				color: #ffffff;
			}

			.homeBusiness_p4 {
				margin: 30px 0 20px 0;
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				line-height: 30px;
				color: #ffffff;
			}
		}
	}

	.xuanfu {
		position: relative;
		min-width: 1200px;
		height: 300px;

		div {
			height: 300px;
			cursor: pointer;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
		}

		.bottom_text {
			position: absolute;
			width: 100%;
			background-color: rgba(0, 0, 0, 0.6);
			bottom: 0;
			height: 40px;
			line-height: 40px;
			color: #fff;
			padding-left: 10px;
			box-sizing: border-box;
			text-align: center;
		}
	}

	//新闻
	.home_new {
		// margin-top: 40px;

		padding: 30px 0px 50px 0px;
		width: 100%;
		// height: 50vh;
		background-image: url(../assets/home/bac2.png);
		background-position: center;
		background-size: 100%;

		.homeN_img {
			display: flex;

			div {
				position: relative;

				.diyige {
					height: 100%;
					width: 500px;
					cursor: pointer;
					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;

				}

				.bottom_text {
					position: absolute;
					width: 100%;
					background-color: rgba(0, 0, 0, 0.6);
					bottom: 0;
					// height: 40px;
					// line-height: 40px;
					color: #fff;
					padding-left: 10px;
					box-sizing: border-box;
				}
			}

			.homeN_div {
                
                overflow-y: scroll;
								// overflow: hidden;

                max-height: 390px;
				flex: 1;
				display: flex;
				flex-direction: column;

				background: #fff;
				.homeN_img1 {
					display: flex;
					padding: 20px 0 20px 20px;
					cursor: pointer;
					div {
						img {
							width: 90px;
							height: 90px;
						}
					}

					.homeN_p {
						flex: 1;
						padding: 0 20px;
						font-size: 14px;
						box-sizing: border-box;
						margin-top: 10px;
						font-family: Microsoft YaHei;
						font-weight: 400;
						color: #2f2f2f;

						.homeN_p1 {
							text-align: left;
							padding-right: 20px;
							
						}

						.homeN_p2 {
							margin-top: 10px;
							text-align: right;
							padding-right: 10px;
						}
					}
				}
				.homeN_img1:hover{
					background-color: rgb(233,241,250);
				}
				.selected{
					background-color: rgb(233,241,250);
				}
			}
		}

		.home_b1 {
			display: grid;
			width: 62.5%;
			margin: auto;
			place-items: center;

			.homenew_p1 {
				margin-top: 10px;
				font-size: 30px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #242424;
			}

			.homenew_p2 {
				margin-top: 10px;
				width: 50px;
				height: 2px;
				background: #ff9c22;
			}

			.homenew_p3 {
				margin-top: 5px;
				margin-bottom: 30px;
				font-size: 30px;
				font-family: Arial;
				font-weight: bold;
				color: #0083c9;
			}
		}
	}

	//在线留言
	.home_message {
		// height: 40vh;
		display: grid;
		width: 62.5%;
		margin: auto;
		padding: 20px 0 20px 0;
		grid-template-columns: 1fr 1fr;

		.homeM_right {
			padding-top: 85px;
			padding-left: 30px;
			width: 100%;
		}

		.homeM_left {
			.homeM_p1 {
				font-size: 25px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #2f2f2f;
			}

			.homeM_p2 {
				font-size: 25px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #7a7a7a;
			}

			::v-deep.el-button {
				border: 1px solid #fff;
			}
		}
	}

	//外部链接
	.homeJ {
		height: 20vh;
		width: 100%;
		text-align: center;
		background: #5e6476;
		display: grid;
		place-items: center;
		padding: 10px 0px 20px 0px;

		.homeJ_p {
			font-size: 25px;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #ffffff;
		}

		.homeJ_body {
			display: grid;
			width: 80%;
			margin: 20px 0px;
			margin: auto;
			place-items: center;
			grid-template-columns: repeat(11, 1fr);
			grid-column-gap: 10px;
			grid-template-rows: 1fr 1fr;
			grid-row-gap: 20px;

			.homeJ_div {
				display: grid;
				width: 90%;

				place-items: center;
				border: 1px solid #bfbfbf;
				color: #bfbfbf;
			}
		}
	}

	.el-carousel__container {
		height: 40vh;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n + 1) {
		background-color: #d3dce6;
	}

	/* .el-header {
  position: absolute;
} */
	.swiper-slide {
		font-size: 24px;
		// text-align: center;
		// line-height: 100px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-content: center;

		.page {
			text-align: center;
			height: 100px;
			overflow: hidden;

			h3,
			p {
				font-size: 40px;
				font-weight: 400;
				color: #fff;
			}
		}

		.slogan {
			text-align: center;
			font-size: 50px;
			color: #fff;
			padding: 30px 0;
		}
	}

	.gundong {
		width: 100%;
		height: 594px;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center;
	}
</style>
